var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFFax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.08,
    height: 19.405,
    viewBox: "0 0 22.08 19.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-51.3 -120.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1819251863728",
    transform: "translate(51.3 120.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M71.439,277.43h-18.2a1.943,1.943,0,0,0-1.941,1.941v3.881a1.943,1.943,0,0,0,1.941,1.94h2.631v-.647a1.943,1.943,0,0,1,1.941-1.94h9.056a1.943,1.943,0,0,1,1.94,1.94v.647h2.631a1.943,1.943,0,0,0,1.941-1.94v-3.881a1.943,1.943,0,0,0-1.941-1.941Zm-6.511,3.234a.647.647,0,1,1,.647-.647A.647.647,0,0,1,64.927,280.664Zm2.587,0a.647.647,0,1,1,.647-.647A.647.647,0,0,1,67.515,280.664Z",
    transform: "translate(-51.3 -269.668)",
    fill: "#CEA663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M339.91,121.81v2.522h2.522a3.242,3.242,0,0,0-2.522-2.522Z",
    transform: "translate(-325.636 -121.745)",
    fill: "#CEA663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M157.457,120.49a.647.647,0,0,0-.647.647v5.821h11.643v-2.587h-3.234a.647.647,0,0,1-.647-.647V120.49Z",
    transform: "translate(-151.592 -120.49)",
    fill: "#CEA663"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M179.6,413.385a.646.646,0,0,0,.646-.647v-3.881a.646.646,0,0,0-.646-.647h-9.056a.646.646,0,0,0-.646.646v3.881a.646.646,0,0,0,.646.647H179.6Zm-7.116-3.234h5.175a.647.647,0,1,1,0,1.294h-5.175a.647.647,0,1,1,0-1.294Z",
    transform: "translate(-164.034 -393.98)",
    fill: "#CEA663"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFFax);
export default __webpack_public_path__ + "static/media/f-fax.19de1817993be19f6254f53913a847a9.svg";
export { ForwardRef as ReactComponent };